import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ImageModule } from '@df/module-image/image.module';
import { CarouselModule } from '@df/ui-carousel/carousel.module';
import { BgColorOptions, ColorOptions, HorizontalAlignmentOptions } from '@df/ui/atomic/atomic-options';
import { HrefComponent } from '@df/ui/common/href/href.component';
import { IfSizeDirective } from '@df/ui/common/if-size.directive';
import { SizeClassDirective } from '@df/ui/common/size-class.directive';
import { UiComponent } from '@df/ui/ui.component';
import { ICmsClientModule } from '@icms/client/icms-client.module';
import { ICmsComponent, ICmsContent, NICmsContentComponent, NICmsContentField } from '@icms/core/content';
export interface ILargeCarouselSlide {
    image?: string;
    image_link?: string;
    main_title?: string;
    title_1?: string;
    cta_copy?: string;
    cta_link?: string;
    color?: string;
    bg_color?: string;
}
export interface IPageComponentLargeCarouselData extends NICmsContentComponent.IData {
    slides: ILargeCarouselSlide[];
    section_title?: string;
    variant: 'textOnImage' | 'textBelowImage';
    text_align: string;
}

let uid = 0;
@Component({
    selector: 'large-carousel',
    templateUrl: 'large-carousel.html',
    styleUrls: ['large-carousel.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [CommonModule, SizeClassDirective, IfSizeDirective, HrefComponent, ImageModule, CarouselModule, ICmsClientModule]
})
@ICmsComponent<LargeCarouselComponent>({
    id: 'large_carousel_layout',
    name: 'Large Carousel Layout',
    tags: ['Large', 'Carousel', 'Editorial'],
    fields: [
        <NICmsContentField.IChoiceField>{
            key: 'variant',
            type: NICmsContentField.EFieldType.choice,
            title: 'Variant',
            required: true,
            options: [
                {
                    key: 'textOnImage',
                    title: 'Text On Image'
                },
                {
                    key: 'textBelowImage',
                    title: 'Text Below Image'
                }
            ],
            default: 'textOnImage'
        },
        <NICmsContentField.IChoiceField>{
            key: 'text_align',
            type: NICmsContentField.EFieldType.choice,
            title: 'Horizontal text alignment',
            options: HorizontalAlignmentOptions,
            default: 'left',
            required: true,
            canShow: data => data.variant === 'textBelowImage'
        },
        {
            type: NICmsContentField.EFieldType.text,
            key: 'section_title',
            title: 'Section Title'
        },
        <NICmsContentField.IRepeaterField>{
            type: NICmsContentField.EFieldType.repeater,
            key: 'slides',
            title: 'Slide',
            itemName: 'Slide',
            itemNameField: 'Slide',
            defaultSize: 3,
            minSize: 3,
            fields: [
                <NICmsContentField.IField>{
                    type: NICmsContentField.EFieldType.image,
                    key: 'image',
                    title: 'Image'
                },
                {
                    type: NICmsContentField.EFieldType.text,
                    key: 'image_link',
                    title: 'Link'
                },
                {
                    type: NICmsContentField.EFieldType.text,
                    key: 'main_title',
                    title: 'Main Title'
                },
                {
                    type: NICmsContentField.EFieldType.text,
                    key: 'title_1',
                    title: 'Title 1'
                },
                {
                    type: NICmsContentField.EFieldType.text,
                    key: 'cta_copy',
                    title: 'CTA copy'
                },
                {
                    type: NICmsContentField.EFieldType.text,
                    key: 'cta_link',
                    title: 'CTA Link'
                },
                <NICmsContentField.IChoiceField>{
                    key: 'color',
                    type: NICmsContentField.EFieldType.choice,
                    title: 'Font Colour',
                    options: ColorOptions,
                    default: 'col-w'
                },
                <NICmsContentField.IChoiceField>{
                    key: 'bg_color',
                    type: NICmsContentField.EFieldType.choice,
                    title: 'Background Colour',
                    options: BgColorOptions,
                    default: 'bg-col-5'
                }
            ]
        }
    ]
})
export class LargeCarouselComponent extends UiComponent implements NICmsContentComponent.IComponent {
    @ICmsContent({
        type: 'component'
    })
    component!: IPageComponentLargeCarouselData;

    uid = `large-carousel-${uid++}`;

    get slidesPerView(): number | 'auto' {
        return [1, 1, 'auto', 'auto'][this.client.sizeId] as number | 'auto';
    }
}
